export { default } from './part-checkbox';
